export default {
  subtitle: 'LaTeX, z ktorého sa vytvára obsah správy. Ponechajte prázdne, ak chcete použiť predvolený obsah.',
};
